<template>
    <b-input-group>
        <template #prepend>
        <b-input-group-text>
            <i class="material-icons">search</i>
        </b-input-group-text>
        </template>
        <b-form-input 
            id="input-search" 
            v-model="filter" 
            @keyup="() => setFilters({ ...filters, ...{filter} })"
            placeholder="Suche ..."
        ></b-form-input>
    </b-input-group>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      filter: '',
    }
  },
  computed: {
    ...mapGetters(['filters']),
  },
  methods: {
    ...mapMutations(['addFilter', 'setFilters'])
  },
  mounted() {
    this.addFilter({filter: this.filter})
  },
  watch:{
    filters: function(val) {
      this.filter =  val.filter;
    }
  }
};
</script>
